"use client";

import { useState, useEffect, useCallback } from "react";
import { Segmant, Title } from "../../../components/index.js";
import Map from "./map.js";
import { getdetailhomelist } from "../../../modules/Graphql/Detailhomegraphql.js";
import {
  getMlslistings,
  getSlipstreamListings,
} from "../../../modules/Graphql/Nhmaphomegraphql.js";

export default function NeighborhoodMapSection({
  nhdetails,
  npiscore,
  npirank,
  isMobile = false,
}) {
  const [homes, setHomes] = useState([]);
  const [markerdatas, setMarkerdatas] = useState([]);

  const getNhHomesList = useCallback(() => {
    if (!nhdetails || nhdetails.length === 0) return;

    const data = nhdetails[0];
    let geo_cords = data.geometry_cords[0];
    let newdata = JSON.parse(geo_cords);
    let datas = [];
    let reservdedata = newdata.map((item2, index2) => {
      datas.push(item2.y + " " + item2.x);
    });
    let finallatlng = datas.reverse().toString();
    let appdata = { coordinate: finallatlng, page: "nhmap" };
    const getdatanew = {
      appdata,
    };

    //For Database listings
    let dbdatas = [];
    let dbreservdedata = newdata.map((item2, index2) => {
      dbdatas.push(item2.x + " " + item2.y);
    });

    let dbfinaldata = dbdatas.toString();
    const dbgetdatanew = {
      start: 0,
      limit: 1,
      orderBy: "OnMarketDate",
      order: dbfinaldata,
      fields: [
        {
          name: "neighborhoodId",
          value: "",
          operator: "!=",
        },
      ],
    };

    Promise.all([
      getMlslistings(getdatanew),
      getdetailhomelist(dbgetdatanew),
      getSlipstreamListings(getdatanew), // New API added
    ])
      .then((result) => {
        let righthomedata = [];

        // Add MLS Listings if available
        if (
          result[0]?.data?.getMlslistings &&
          Array.isArray(result[0].data.getMlslistings)
        ) {
          righthomedata.push(...result[0].data.getMlslistings);
        }

        // Add Detailed Home Listings if available
        if (
          result[1]?.data?.getdetailhome &&
          Array.isArray(result[1].data.getdetailhome) &&
          result[1].data.getdetailhome.length > 0
        ) {
          righthomedata.push(...result[1].data.getdetailhome);
        }

        // Add Slipstream Listings if available (New API integration)
        if (
          result[2]?.data?.getSlipstreamListings &&
          Array.isArray(result[2].data.getSlipstreamListings)
        ) {
          righthomedata.push(...result[2].data.getSlipstreamListings);
        }

        // Update state with home data
        setHomes(righthomedata);

        // Prepare marker data
        let markerdata = righthomedata.map((item2) => {
          let price;
          if (item2.MlsStatus === "Sold") {
            price = item2.ClosePrice;
          } else if (Number.isInteger(item2.ListPrice)) {
            price = item2.ListPrice;
          }

          return {
            id: item2.ListingKeyNumeric,
            lat: item2.Latitude,
            lang: item2.Longitude,
            price: price,
          };
        });

        // Update state with marker data
        setMarkerdatas(markerdata);
      })
      .catch((error) => {
        console.error("Error fetching home listings:", error);
      });
  }, [nhdetails]);

  useEffect(() => {
    if (nhdetails && nhdetails.length > 0) {
      getNhHomesList();
    }
  }, [nhdetails, getNhHomesList]);

  if (!nhdetails || nhdetails.length === 0) {
    return null;
  }

  const data = nhdetails[0];
  const lat = data?.latitude ? parseFloat(data.latitude) : "";
  const lng = data?.longitude ? parseFloat(data.longitude) : "";
  const poly_data =
    data?.geometry_cords && data.geometry_cords.length > 0
      ? JSON.parse(data.geometry_cords[0])
      : "";
  const nhname = data?.label;

  // Use the raw npi value from neighborhood data for color calculation
  const npi = data?.npi ? data.npi : 0;

  const handleviewclick = () => {
    localStorage.setItem("ispagemain", true);
    window.open(`/?address=${data?.label}, USA`, "_blank");
  };

  return (
    <>
      <Segmant>
        <Title name="Neighborhood Map" size="medium" as="h2" />
        <div className="detailnh_map_right">
          <Map
            poly_data={poly_data}
            lat={lat}
            lng={lng}
            homes={markerdatas}
            showmarkers={"true"}
            mapheight={250}
            npiscore={npi}
            npirank={npirank}
            nhdetails={nhdetails}
          />
        </div>
      </Segmant>
      <p onClick={() => handleviewclick()} className="fullmapview">
        View Full Map
      </p>
    </>
  );
}
